/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  RewardContract,
  RewardContractInterface,
} from "../../../../contracts/fwen/FwenMultiStaker.sol/RewardContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "rewardStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class RewardContract__factory {
  static readonly abi = _abi;
  static createInterface(): RewardContractInterface {
    return new utils.Interface(_abi) as RewardContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardContract {
    return new Contract(address, _abi, signerOrProvider) as RewardContract;
  }
}
